import React from 'react';
import ToastPortal from '../ToastPortal';
import { Toast } from './Toast';
import { LongToast, shouldUseLongToast } from './LongToast';

/**
 * Rendu d'une notification, selon le motif de DESIGN-SYSTEM.md.
 *
 * `ToastPortal` sort le message de la pile d'un `Dialog` : sans lui, un toast
 * déclenché depuis un modal s'affiche SOUS l'assombrissement de Radix.
 * `shouldUseLongToast` bascule sur le format centré au-delà de 130 caractères —
 * c'est ce qui évite de tronquer les messages du serveur, les plus longs.
 *
 * S'utilise avec `useNotification` :
 *
 *   const { notification, notifier, masquer } = useNotification();
 *   ...
 *   <PorteurNotification notification={notification} onFermer={masquer} />
 */
const PorteurNotification = ({ notification, onFermer }) => {
  if (!notification) return null;

  const { message, type = 'success', title } = notification;

  return (
    <ToastPortal>
      {shouldUseLongToast(message, type, notification) ? (
        <LongToast
          show
          title={title}
          message={message}
          type={type}
          onClose={onFermer}
        />
      ) : (
        <Toast message={message} type={type} onClose={onFermer} />
      )}
    </ToastPortal>
  );
};

export default PorteurNotification;
